import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { mapRawToProject } from "@/mappers/project";
import { RawProject, CreateProject, ArchiveProject, UpdateProject } from "@/types/project";
import {
  SWRApiError,
  swrConfigOptions,
  UpdaterParams,
  useFetcher,
  useMutater,
  useUpdater,
} from "./swr";

export const useProjects = () => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawProject[], SWRApiError>(
    { url: "/projects" },
    fetcher,
    swrConfigOptions,
  );

  return { data: data.map(mapRawToProject), ...rest };
};

export const useCreateProject = () => {
  const mutater = useMutater();

  return useSWRMutation<any, SWRApiError, string, CreateProject>("/projects", mutater);
};

export const useUpdateProject = () => {
  const updater = useUpdater();

  return useSWRMutation<void, SWRApiError, UpdaterParams, UpdateProject & { id: string }>(
    { url: "/projects" },
    updater,
  );
};

export const useArchiveProject = () => {
  const updater = useUpdater();

  return useSWRMutation<void, SWRApiError, UpdaterParams, ArchiveProject>(
    { url: "/projects", action: "archive" },
    updater,
  );
};
